import { render, staticRenderFns } from "./CatalogueProductData.vue?vue&type=template&id=1988164e&scoped=true"
import script from "./CatalogueProductData.vue?vue&type=script&lang=js"
export * from "./CatalogueProductData.vue?vue&type=script&lang=js"
import style0 from "./CatalogueProductData.vue?vue&type=style&index=0&id=1988164e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988164e",
  null
  
)

export default component.exports